module.exports = __webpack_public_path__ + "static/img/midground.3cf5eb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-hall/midground.svg
// module id = 180
// module chunks = 2